/* eslint-disable */
import {
  update,
  create,
  getOrders,
  getUserPref,
  updateUserPref
} from '@/calls/profile';
import { getAttraction } from '@/calls/event';
import { like as likeEvent } from '@/calls/likes';
import { fields } from '@/data/static/profile.json';
import Vue from 'vue';

const profile = {
  namespaced: true,
  state: {
    requests: 0,
    requestsEvents: 0,
    orders: {
      limit: 10,
      noMore: false,
      items: [],
      ticket: null
    },
    startInfos: {},
    infos: {},
    events: [],
    pref: {
      reminder: true,
      likes: [],
      timestamps: {}
    }
  },
  mutations: {
    setOrders(state, orders) {
      state.orders.items = orders;
    },
    addOrders(state, orders) {
      orders.map(order => {
        state.orders.items.push(order);
      });
    },
    setTicket(state, ticket) {
      state.orders.ticket = ticket;
    },
    updateNoMore(state, flag) {
      state.orders.noMore = flag;
    },
    updateInfos(state, infos) {
      state.infos = infos;
      state.startInfos = { ...infos };
      localStorage.setItem('profile-data', JSON.stringify(infos));
    },
    updateInfo(state, { type, value }) {
      state.infos[type] = value;
    },
    updatePref(state, { type, value }) {
      state.pref[type] = value;
    },
    setLike(state, { id, event }) {
      state.pref.likes.push(id);
      state.pref.timestamps[id] = Date.now();

      if (event) {
        state.events.push(event);
      }
    },
    removeLike(state, { index, event }) {
      let ind = -1;

      for (let i = 0; i < state.events.length; i++) {
        const e = state.events[i];
        if (e.id === event.id) {
          ind = i;
          break;
        }
      }

      if (state.pref.timestamps[state.events[ind].id]) {
        delete state.pref.timestamps[state.events[ind].id];
      }

      state.events.splice(ind, 1);
      state.pref.likes.splice(index, 1);
    },
    resetInfos(state) {
      fields.map(field => {
        Vue.set(state.infos, field.name, '');
      });
    },
    increaseRequests(state, type) {
      if (type) {
        state[type] += 1;
        return;
      }

      state.requests += 1;
    },
    decreaseRequests(state, type) {
      if (type) {
        state[type] -= 1;
        return;
      }

      state.requests -= 1;
    },
    pushEvent(state, event) {
      state.events.push(event);
    },
    resetPref(state) {
      state.pref.reminder = true;
      state.pref.likes = [];
    },
    resetEvents(state) {
      state.events = [];
    }
  },
  actions: {
    async update({ state, commit }) {
      commit('increaseRequests');

      const propertiesToUpdate = {};
      const properties = Object.keys(state.infos);

      properties.map(prop => {
        if (state.infos[prop] !== state.startInfos[prop]) {
          propertiesToUpdate[prop] = state.infos[prop];
        }
      });

      if (Object.keys(propertiesToUpdate).length !== 0) {
        const request = await update(propertiesToUpdate, state.infos.id);

        if (request.success && !request.error && request.data) {
          commit('updateInfos', request.data);
        }
      }

      commit('decreaseRequests');
    },
    async create({ state, commit, dispatch }) {
      commit('increaseRequests');

      const { id } = state.infos;
      const request = await create({ ...state.infos });

      if (request.success) {
        commit('updateInfos', request.data);
        commit('login/setLogged', true, { root: true });

        if (!id) {
          dispatch('checkUserPref');
        }
      }

      commit('decreaseRequests');
    },
    async getOrders({ state, commit }) {
      commit('increaseRequests');

      const request = await getOrders({
        limit: state.orders.limit,
        contactid: state.infos.id
      });

      if (request.success) {
        if (request.data.length < state.limit) {
          commit('updateNoMore', true);
        }

        commit('setOrders', request.data);
      }

      commit('decreaseRequests');
    },
    async nextOrders({ state, commit }) {
      commit('increaseRequests');

      const request = await getOrders({
        limit: state.orders.limit,
        offset: state.orders.items.length,
        contactid: state.infos.id
      });

      if (request.success) {
        if (request.data.length < state.limit) {
          commit('updateNoMore', true);
        }

        commit('addOrders', request.data);
      }

      commit('decreaseRequests');
    },
    async checkUserPref({ state, commit, dispatch }) {
      // First : check for saved pref
      if (state.infos.id) {
        const request = await getUserPref(state.infos.id);
        const { data } = request;

        if (request.success) {
          if (data) {
            // User has saved preference
            if (data.reminder === false) {
              // User has saved reminder
              commit('updatePref', {
                type: 'reminder',
                value: data.reminder
              });
            }

            if (data.likes) {
              // User has saved likes
              commit('updatePref', {
                type: 'likes',
                value: data.likes
              });
            }
          }
        }
      }

      const userPref = localStorage.getItem('user-pref');

      if (userPref) {
        const pref = JSON.parse(userPref);
        let diff = false;

        if (pref.reminder === false) {
          commit('updatePref', {
            type: 'reminder',
            value: pref.reminder
          });
        }

        if (pref.likes) {
          pref.likes.map(like => {
            const index = state.pref.likes.indexOf(like);
            if (index < 0) {
              commit('setLike', { id: like });
              diff = true;
            }
          });
        }

        if (state.infos.id && diff) {
          dispatch('savePref');
        }
      }

      if (state.pref.likes.length > 0) {
        dispatch('getEventsFromLikes');
      }
    },
    async savePref({ state }) {
      const pref = JSON.stringify(state.pref);
      localStorage.setItem('user-pref', pref);

      if (state.infos && state.infos.id) {
        // eslint-disable-next-line
        const request = await updateUserPref({
          user: state.infos.id, pref: state.pref
        });
      }
    },
    async like({ commit, dispatch, state }, { event, user, update, eventFull }) {
      const index = state.pref.likes.indexOf(event);
      let remove = false;

      if (index >= 0) {
        commit('removeLike', {
          index,
          event: eventFull
        });
        remove = true;
      } else {
        commit('setLike', {
          id: event,
          event: eventFull
        });
      }

      // eslint-disable-next-line
      const request = await likeEvent({
        event, user, remove, pref: null
      });

      if (update) {
        dispatch(`${update}/updateLikes`, event, { root: true });
      }

      dispatch('savePref');
    },
    async getEventsFromLikes({ commit, state }, ) {
      commit('increaseRequests', 'requestsEvents');
      const { likes } = state.pref;

      for (let i = 0; i < likes.length; i++) {
        const lke = likes[i];
        const ind = -1;
        state.events.map((e, index) => {
          if (e.id === lke) {
            ind = index;
          }
        });

        if (ind < 0) {
          const request = await getAttraction(lke);

          if (request.success) {
            commit('pushEvent', request.data);
          }
        }
      }

      commit('decreaseRequests', 'requestsEvents');
    },
    logout({ commit, dispatch }) {
      commit('updateInfos', {});
      localStorage.removeItem('profile-data');
      commit('setOrders', []);
      commit('resetPref');
      commit('resetEvents');
      dispatch('savePref');
    },
    checkTimestamps({ state }) {
      for (let i = 0; i < state.pref.likes.length; i++) {
        const like = state.pref.likes[i];
        if (!state.pref.timestamps[like]) {
          state.pref.timestamps[like] = new Date.now();
        }
      }
    }
  }
};

export default profile;
